<template>
  <div class="container mt-5">
    <h1>Database</h1>

    <div v-if="!loggedIn" class="login-container">
      <authComponent @success="loginSuccess" />
    </div>

    <div v-else>
      <h2>Beacons</h2>
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="table-dark">
            <tr>
              <th>MAC</th>
              <th>Latitude</th>
              <th>Longitude</th>
              <th>Height</th>
              <th>Level ID</th>
              <th>Location</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="beacon in beacons" :key="beacon.id">
              <td v-if="!beacon.edit">{{ beacon.beacon_mac }}</td>
              <td v-else>
                <input type="text" v-model.trim="beacon.beacon_mac" class="form-control" />
              </td>
              <td v-if="!beacon.edit">{{ beacon.latitude }}</td>
              <td v-else>
                <input type="number" v-model.trim="beacon.latitude" class="form-control" />
              </td>
              <td v-if="!beacon.edit">{{ beacon.longitude }}</td>
              <td v-else>
                <input type="number" v-model.trim="beacon.longitude" class="form-control" />
              </td>
              <td v-if="!beacon.edit">{{ beacon.height }}</td>
              <td v-else>
                <input type="number" v-model.trim="beacon.height" class="form-control" />
              </td>
              <td v-if="!beacon.edit">{{ beacon.level_id }}</td>
              <td v-else>
                <input type="text" v-model.trim="beacon.level_id" class="form-control" />
              </td>
              <td v-if="!beacon.edit">
                {{
                  locations.find((location) => location.location_id === beacon.location_id)
                    .location_name
                }}
              </td>
              <td v-else>
                <select v-model.trim="beacon.location_id" class="form-select">
                  <option
                    v-for="location in locations"
                    :key="location.location_id"
                    :value="location.location_id"
                  >
                    {{ location.location_name }}
                  </option>
                </select>
              </td>
              <td>
                <div class="row">
                  <div class="col">
                    <button @click="deleteBeacon(beacon.beacon_id)" class="btn btn-danger w-100">
                      Delete
                    </button>
                  </div>
                  <div class="col">
                    <button
                      @click="editBeacon(beacon.beacon_id)"
                      class="btn btn-primary w-100 mt-1"
                    >
                      {{ beacon.edit ? 'Save' : 'Edit' }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div v-if="beacon.edit" class="col">
                    <button @click="beacon.edit = !beacon.edit" class="btn btn-secondary w-100">
                      Cancel
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  v-model.trim="newBeacon.beacon_mac"
                  placeholder="MAC"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.trim="newBeacon.latitude"
                  placeholder="Latitude"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.trim="newBeacon.longitude"
                  placeholder="Longitude"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.trim="newBeacon.height"
                  placeholder="Height"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model.trim="newBeacon.level_id"
                  placeholder="Level ID"
                  class="form-control"
                />
              </td>
              <td>
                <select v-model.trim="newBeacon.location_id" class="form-select">
                  <option
                    v-for="location in locations"
                    :key="location.location_id"
                    :value="location.location_id"
                  >
                    {{ location.location_name }}
                  </option>
                </select>
              </td>
              <td><button @click="addBeacon" class="btn btn-success w-100">Add</button></td>
            </tr>
          </tbody>
        </table>
        <p v-if="newBeacon.errormsg" class="text-danger">{{ newBeacon.errormsg }}</p>

        <h2>Locations</h2>
        <table class="table table-bordered table-striped">
          <thead class="table-dark">
            <tr>
              <th>Name</th>
              <th>Path Loss Exponent</th>
              <th>Reference RSSI</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="location in locations" :key="location.id">
              <td v-if="!location.edit">{{ location.location_name }}</td>
              <td v-else>
                <input type="text" v-model.trim="location.location_name" class="form-control" />
              </td>
              <td v-if="!location.edit">{{ location.path_loss_exponent }}</td>
              <td v-else>
                <input
                  type="number"
                  v-model.trim="location.path_loss_exponent"
                  class="form-control"
                />
              </td>
              <td v-if="!location.edit">{{ location.reference_rssi }}</td>
              <td v-else>
                <input type="number" v-model.trim="location.reference_rssi" class="form-control" />
              </td>
              <td>
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <button
                      @click="deleteLocation(location.location_id)"
                      class="btn btn-danger w-100"
                    >
                      Delete
                    </button>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <button
                      @click="editlocation(location.location_id)"
                      class="btn btn-primary w-100"
                    >
                      {{ location.edit ? 'Save' : 'Edit' }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div v-if="location.edit" class="col">
                    <button @click="location.edit = !location.edit" class="btn btn-secondary w-100">
                      Cancel
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  v-model.trim="newLocation.location_name"
                  placeholder="Name"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.trim="newLocation.path_loss_exponent"
                  placeholder="Path Loss Exponent"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.trim="newLocation.reference_rssi"
                  placeholder="Reference RSSI"
                  class="form-control"
                />
              </td>
              <td><button @click="addLocation" class="btn btn-success w-100">Add</button></td>
            </tr>
          </tbody>
        </table>
        <p v-if="newLocation.errormsg" class="text-danger">{{ newLocation.errormsg }}</p>

        <h2>Stations</h2>
        <table class="table table-bordered table-striped">
          <thead class="table-dark">
            <tr>
              <th>MAC</th>
              <th>Latitude</th>
              <th>Longitude</th>
              <th>Location</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="station in stations" :key="station.id">
              <td v-if="!station.edit">{{ station.ble_mac }}</td>
              <td v-else>
                <input type="text" v-model.trim="station.ble_mac" class="form-control" />
              </td>
              <td v-if="!station.edit">{{ station.latitude }}</td>
              <td v-else>
                <input type="number" v-model.trim="station.latitude" class="form-control" />
              </td>
              <td v-if="!station.edit">{{ station.longitude }}</td>
              <td v-else>
                <input type="number" v-model.trim="station.longitude" class="form-control" />
              </td>
              <td v-if="!station.edit">
                {{
                  locations.find((location) => location.location_id === station.location_id)
                    .location_name
                }}
              </td>
              <td v-else>
                <select v-model.trim="station.location_id" class="form-select">
                  <option
                    v-for="location in locations"
                    :key="location.location_id"
                    :value="location.location_id"
                  >
                    {{ location.location_name }}
                  </option>
                </select>
              </td>
              <td>
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <button @click="deleteStation(station.station_id)" class="btn btn-danger w-100">
                      Delete
                    </button>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <button @click="editStation(station.station_id)" class="btn btn-primary w-100">
                      {{ station.edit ? 'Save' : 'Edit' }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div v-if="station.edit" class="col">
                    <button @click="station.edit = !station.edit" class="btn btn-secondary w-100">
                      Cancel
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  v-model.trim="newStation.ble_mac"
                  placeholder="MAC"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.trim="newStation.latitude"
                  placeholder="Latitude"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="number"
                  v-model.trim="newStation.longitude"
                  placeholder="Longitude"
                  class="form-control"
                />
              </td>
              <td>
                <select v-model.trim="newStation.location_id" class="form-select">
                  <option
                    v-for="location in locations"
                    :key="location.location_id"
                    :value="location.location_id"
                  >
                    {{ location.location_name }}
                  </option>
                </select>
              </td>
              <td><button @click="addStation" class="btn btn-success w-100">Add</button></td>
            </tr>
          </tbody>
        </table>
        <p v-if="newStation.errormsg" class="text-danger">{{ newStation.errormsg }}</p>

        <h2>Gateways</h2>
        <table class="table table-bordered table-striped">
          <thead class="table-dark">
            <tr>
              <th>Name</th>
              <th>MAC</th>
              <th>Location ID</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="gateway in gateways" :key="gateway.id">
              <td v-if="!gateway.edit">{{ gateway.gateway_name }}</td>
              <td v-else>
                <input type="text" v-model.trim="gateway.gateway_name" class="form-control" />
              </td>
              <td v-if="!gateway.edit">{{ gateway.gateway_mac }}</td>
              <td v-else>
                <input type="text" v-model.trim="gateway.gateway_mac" class="form-control" />
              </td>
              <td v-if="!gateway.edit">
                {{
                  locations.find((location) => location.location_id === gateway.location_id)
                    .location_name
                }}
              </td>
              <td v-else>
                <select v-model.trim="gateway.location_id" class="form-select">
                  <option
                    v-for="location in locations"
                    :key="location.location_id"
                    :value="location.location_id"
                  >
                    {{ location.location_name }}
                  </option>
                </select>
              </td>
              <td>
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <button @click="deleteGateway(gateway.gateway_id)" class="btn btn-danger w-100">
                      Delete
                    </button>
                  </div>
                  <div class="col-lg-6 col-md-12">
                    <button @click="editGateway(gateway.gateway_id)" class="btn btn-primary w-100">
                      {{ gateway.edit ? 'Save' : 'Edit' }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div v-if="gateway.edit" class="col">
                    <button @click="gateway.edit = !gateway.edit" class="btn btn-secondary w-100">
                      Cancel
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  v-model.trim="newGateway.gateway_name"
                  placeholder="Name"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model.trim="newGateway.gateway_mac"
                  placeholder="MAC"
                  class="form-control"
                />
              </td>
              <td>
                <select v-model.trim="newGateway.location_id" class="form-select">
                  <option
                    v-for="location in locations"
                    :key="location.location_id"
                    :value="location.location_id"
                  >
                    {{ location.location_name }}
                  </option>
                </select>
              </td>
              <td><button @click="addGateway" class="btn btn-success w-100">Add</button></td>
            </tr>
          </tbody>
        </table>
        <p v-if="newGateway.errormsg" class="text-danger">{{ newGateway.errormsg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import authComponent from '@/components/auth.vue'

export default {
  name: 'databasePage',
  data() {
    return {
      loggedIn: false,
      beacons: [],
      newBeacon: {
        errormsg: '',
        beacon_mac: '',
        latitude: '',
        longitude: '',
        height: '',
        level_id: '',
        location_id: ''
      },
      locations: [],
      newLocation: {
        errormsg: '',
        location_name: '',
        path_loss_exponent: '',
        reference_rssi: ''
      },
      stations: [],
      newStation: {
        errormsg: '',
        ble_mac: '',
        latitude: '',
        longitude: '',
        location_id: ''
      },
      gateways: [],
      newGateway: {
        errormsg: '',
        gateway_name: '',
        gateway_mac: '',
        location_id: ''
      },
      tags: [],
      newTag: {
        errormsg: '',
        tag_mac: ''
      }
    }
  },
  components: {
    authComponent
  },
  methods: {
    loginSuccess() {
      this.loggedIn = true
    },
    async fetchBeacons() {
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/beacons', {
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.beacons = await response.json()
          this.beacons = this.beacons.sort((a, b) => a.beacon_id - b.beacon_id)
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to fetch beacons:', response)
        }
      } catch (error) {
        console.error('An error occurred during beacon fetch:', error)
      }
    },

    async deleteBeacon(id) {
      if (!confirm('Are you sure you want to delete this beacon?')) return
      try {
        const response = await fetch(`https://bachelor.rfid-solutions.no/api/beacons/${id}`, {
          method: 'DELETE',
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.fetchBeacons()
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to delete beacon:', response)
        }
      } catch (error) {
        console.error('An error occurred during beacon deletion:', error)
      }
    },

    async addBeacon() {
      if (
        !this.newBeacon.beacon_mac ||
        !this.newBeacon.latitude ||
        !this.newBeacon.longitude ||
        !this.newBeacon.location_id
      ) {
        this.newBeacon.errormsg = 'Please fill in all fields.'
        return
      } else {
        this.newBeacon.errormsg = ''
      }
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/beacons', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: `${localStorage.getItem('token')}`
          },
          body: JSON.stringify(this.newBeacon)
        })
        if (response.ok) {
          this.fetchBeacons()
          this.newBeacon = {}
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to add beacon:', response)
        }
      } catch (error) {
        console.error('An error occurred during beacon addition:', error)
      }
    },

    async editBeacon(id) {
      const beacon = this.beacons.find((beacon) => beacon.beacon_id === id)
      beacon.edit = !beacon.edit
      if (!beacon.edit) {
        try {
          const response = await fetch(`https://bachelor.rfid-solutions.no/api/beacons/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              authorization: `${localStorage.getItem('token')}`
            },
            body: JSON.stringify(beacon)
          })
          if (response.ok) {
            this.fetchBeacons()
          } else if (response.status === 401) {
            this.loggedIn = false
          } else {
            console.error('Failed to edit beacon:', response)
          }
        } catch (error) {
          console.error('An error occurred during beacon edit:', error)
        }
      }
    },

    async fetchLocations() {
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/locations', {
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.locations = await response.json()
          this.locations = this.locations.sort((a, b) => a.location_id - b.location_id)
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to fetch locations:', response)
        }
      } catch (error) {
        console.error('An error occurred during location fetch:', error)
      }
    },

    async deleteLocation(id) {
      if (!confirm('Are you sure you want to delete this location?')) return
      try {
        const response = await fetch(`https://bachelor.rfid-solutions.no/api/locations/${id}`, {
          method: 'DELETE',
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.fetchLocations()
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to delete location:', response)
        }
      } catch (error) {
        console.error('An error occurred during location deletion:', error)
      }
    },

    async addLocation() {
      if (
        !this.newLocation.location_name ||
        !this.newLocation.path_loss_exponent ||
        !this.newLocation.reference_rssi
      ) {
        this.newLocation.errormsg = 'Please fill in all fields.'
        return
      } else {
        this.newLocation.errormsg = ''
      }
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/locations', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: `${localStorage.getItem('token')}`
          },
          body: JSON.stringify(this.newLocation)
        })
        if (response.ok) {
          this.fetchLocations()
          this.newLocation = {}
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to add location:', response)
        }
      } catch (error) {
        console.error('An error occurred during location addition:', error)
      }
    },

    async editlocation(id) {
      const location = this.locations.find((location) => location.location_id === id)
      location.edit = !location.edit
      if (!location.edit) {
        try {
          const response = await fetch(`https://bachelor.rfid-solutions.no/api/locations/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              authorization: `${localStorage.getItem('token')}`
            },
            body: JSON.stringify(location)
          })
          if (response.ok) {
            this.fetchLocations()
          } else if (response.status === 401) {
            this.loggedIn = false
          } else {
            console.error('Failed to edit location:', response)
          }
        } catch (error) {
          console.error('An error occurred during location edit:', error)
        }
      }
    },

    async fetchStations() {
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/stations', {
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.stations = await response.json()
          this.stations = this.stations.sort((a, b) => a.station_id - b.station_id)
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to fetch stations:', response)
        }
      } catch (error) {
        console.error('An error occurred during station fetch:', error)
      }
    },

    async deleteStation(id) {
      if (!confirm('Are you sure you want to delete this station?')) return
      try {
        const response = await fetch(`https://bachelor.rfid-solutions.no/api/stations/${id}`, {
          method: 'DELETE',
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.fetchStations()
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to delete station:', response)
        }
      } catch (error) {
        console.error('An error occurred during station deletion:', error)
      }
    },

    async addStation() {
      if (
        !this.newStation.ble_mac ||
        !this.newStation.latitude ||
        !this.newStation.longitude ||
        !this.newStation.location_id
      ) {
        this.newStation.errormsg = 'Please fill in all fields.'
        return
      } else {
        this.newStation.errormsg = ''
      }
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/stations', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: `${localStorage.getItem('token')}`
          },
          body: JSON.stringify(this.newStation)
        })
        if (response.ok) {
          this.fetchStations()
          this.newStation = {}
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to add station:', response)
        }
      } catch (error) {
        console.error('An error occurred during station addition:', error)
      }
    },

    async editStation(id) {
      const station = this.stations.find((station) => station.station_id === id)
      station.edit = !station.edit
      if (!station.edit) {
        try {
          const response = await fetch(`https://bachelor.rfid-solutions.no/api/stations/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              authorization: `${localStorage.getItem('token')}`
            },
            body: JSON.stringify(station)
          })
          if (response.ok) {
            this.fetchStations()
          } else if (response.status === 401) {
            this.loggedIn = false
          } else {
            console.error('Failed to edit station:', response)
          }
        } catch (error) {
          console.error('An error occurred during station edit:', error)
        }
      }
    },

    async fetchGateways() {
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/gateways', {
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.gateways = await response.json()
          this.gateways = this.gateways.sort((a, b) => a.gateway_id - b.gateway_id)
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to fetch gateways:', response)
        }
      } catch (error) {
        console.error('An error occurred during gateway fetch:', error)
      }
    },

    async deleteGateway(id) {
      if (!confirm('Are you sure you want to delete this gateway?')) return
      try {
        const response = await fetch(`https://bachelor.rfid-solutions.no/api/gateways/${id}`, {
          method: 'DELETE',
          headers: {
            authorization: `${localStorage.getItem('token')}`
          }
        })
        if (response.ok) {
          this.fetchGateways()
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to delete gateway:', response)
        }
      } catch (error) {
        console.error('An error occurred during gateway deletion:', error)
      }
    },

    async addGateway() {
      if (
        !this.newGateway.gateway_name ||
        !this.newGateway.gateway_mac ||
        !this.newGateway.location_id
      ) {
        this.newGateway.errormsg = 'Please fill in all fields.'
        return
      } else {
        this.newGateway.errormsg = ''
      }
      try {
        const response = await fetch('https://bachelor.rfid-solutions.no/api/gateways', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            authorization: `${localStorage.getItem('token')}`
          },
          body: JSON.stringify(this.newGateway)
        })
        if (response.ok) {
          this.fetchGateways()
          this.newGateway = {}
        } else if (response.status === 401) {
          this.loggedIn = false
        } else {
          console.error('Failed to add gateway:', response)
        }
      } catch (error) {
        console.error('An error occurred during gateway addition:', error)
      }
    },

    async editGateway(id) {
      const gateway = this.gateways.find((gateway) => gateway.gateway_id === id)
      gateway.edit = !gateway.edit
      if (!gateway.edit) {
        try {
          const response = await fetch(`https://bachelor.rfid-solutions.no/api/gateways/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              authorization: `${localStorage.getItem('token')}`
            },
            body: JSON.stringify(gateway)
          })
          if (response.ok) {
            this.fetchGateways()
          } else if (response.status === 401) {
            this.loggedIn = false
          } else {
            console.error('Failed to edit gateway:', response)
          }
        } catch (error) {
          console.error('An error occurred during gateway edit:', error)
        }
      }
    }
  },
  created() {
    const token = localStorage.getItem('token')
    if (token) {
      this.loggedIn = true
    }
  },
  watch: {
    loggedIn() {
      if (this.loggedIn) {
        this.fetchBeacons()
        this.fetchLocations()
        this.fetchStations()
        this.fetchGateways()
      }
    }
  }
}
</script>
